// extracted by mini-css-extract-plugin
export default {"summaryWrapper":"styles_summaryWrapper__p6HTu","bulletPoints":"styles_bulletPoints__0H8oc","summarizeButton":"styles_summarizeButton__KHR7E"};